import * as categories from '@wix/auto_sdk_online-programs_categories';
import * as instructors from '@wix/auto_sdk_online-programs_instructors';
import * as quizzes from '@wix/auto_sdk_online-programs_quizzes';
import * as onlineProgramParticipants from '@wix/auto_sdk_online-programs_online-program-participants';
import * as participants from '@wix/auto_sdk_online-programs_participants';
import * as programs from '@wix/auto_sdk_online-programs_programs';
import * as sections from '@wix/auto_sdk_online-programs_sections';
import * as steps from '@wix/auto_sdk_online-programs_steps';

export {
  categories,
  instructors,
  quizzes,
  onlineProgramParticipants,
  participants,
  programs,
  sections,
  steps,
};
